
import { Vue, Component, Prop } from 'vue-property-decorator'
import { bus } from 'shared/state/Bus'
@Component
export default class TestSpeechControl extends Vue {

	@Prop() label?: string
	@Prop({ default: '' }) value!: string

	bus = bus
	clicked = false

	onClick() {
		this.clicked = true
		bus.$emit('test_speech', this.label, this.value)
		setTimeout(() => this.clicked = false, 2000)
	}

}
